'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Dialog, DialogContent, DialogTrigger } from '@eliadmin/core/src/components/ui/dialog';

export const MediaSlugContent = ({ mainImage, images }: { mainImage: any; images: any }) => {
  const galleryImages = images?.[0]?.images ?? [];

  return (
    <>
      <div className={cn('', 'ea-media-detail__wrapper')}>
        <div className={cn('', 'ea-media-detail__main-image')}>
          <Image
            src={mainImage?.url || '/images/placeholder.png'}
            alt={resolveImageAlt(mainImage, 'Media image')}
            fill
            style={{ objectFit: 'cover', objectPosition: 'center' }}
            sizes="25vw"
          />
        </div>
        <div className="col-span-3 mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {galleryImages.map((image: any, index: number) => (
            <Dialog key={image.id ?? image.url ?? index}>
              <DialogTrigger asChild>
                <button type="button" className="relative col-span-1 aspect-video w-full">
                  <Image
                    src={image?.url || '/images/placeholder.png'}
                    alt={resolveImageAlt(image, 'Media image')}
                    sizes="25vw"
                    fill
                    objectFit="cover"
                  />
                </button>
              </DialogTrigger>
              <DialogContent className="w-full p-0 sm:max-w-[800px]">
                <div className="relative mx-auto h-[300px] w-full sm:h-[80vh]">
                  <Image
                    src={image?.url || '/images/placeholder.png'}
                    alt={resolveImageAlt(image, 'Media image')}
                    sizes="25vw"
                    fill
                    objectFit="cover"
                  />
                </div>
              </DialogContent>
            </Dialog>
          ))}
        </div>
        <div className={cn('', 'ea-media-detail__images')}></div>
      </div>
    </>
  );
};
